// extracted by mini-css-extract-plugin
module.exports = {"Root":"unpublished-news-preview_Root__54mkw","Header":"unpublished-news-preview_Header__Z8eFI","Delete":"unpublished-news-preview_Delete___XNpK"};